// extracted by mini-css-extract-plugin
export var headerCell = "_47-1";
export var loadingSpinnerContainer = "_47-4";
export var rowWrapper = "_47-3";
export var standaloneTable = "_47-5";
export var table = "_47-0";
export var white = "_47-2";